/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $CompanyStatistics = {
    properties: {
        company: {
    type: 'string',
    isRequired: true,
},
        total: {
    type: 'number',
    isRequired: true,
},
        shifts: {
    type: 'array',
    contains: {
        type: 'Statistics',
    },
    isRequired: true,
},
    },
};